import { render, staticRenderFns } from "./downloaderMainComponent.vue?vue&type=template&id=3f215887&scoped=true&"
import script from "./downloaderMainComponent.vue?vue&type=script&lang=js&"
export * from "./downloaderMainComponent.vue?vue&type=script&lang=js&"
import style0 from "./downloaderMainComponent.vue?vue&type=style&index=0&id=3f215887&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f215887",
  null
  
)

export default component.exports